import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { AppDispatch } from '@/store'
import Api from '@/services/http'
import { countryUrl } from '@/services/url'
import type * as Types from './types'

const initialState: Types.IInitialState = {
  countryList: null,
}

const countrySlice = createSlice({
  name: 'country',
  initialState: initialState,
  reducers: {
    setCountryList(state, action: PayloadAction<Types.ICountry[]>) {
      return {
        ...state,
        countryList: action.payload,
      }
    },
  },
})

export const { setCountryList } = countrySlice.actions

/** 获取国家信息 */
export const getCountryList = (params: Types.ICountryParams) => async (dispatch: AppDispatch) => {
  const response = await Api.admin.get<{ worldList: Types.ICountry[] }>(countryUrl.list, { params })
  const { data, code, message } = response
  if (code === 'SUCCESS') {
    const { worldList } = data
    dispatch(setCountryList(worldList))

    return data
  }

  return Promise.reject({ code, message })
}

export default countrySlice.reducer
